var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-layout",
        {
          staticClass: "section-title",
          attrs: { column: "", "justify-center": "" }
        },
        [_c("div", [_vm._v("reagendar pedido")]), _vm._v(" "), _c("hr")]
      ),
      _vm._v(" "),
      _c("v-layout", { attrs: { column: "", "align-center": "" } }, [
        _c("div", [
          _c("img", {
            attrs: {
              src: _vm.order.professional.account.profile.profile_picture,
              alt: _vm.order.professional.account.first_name
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-capitalize" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("fullName")(_vm.order.professional.account)) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm._f("formatDate")(
                  _vm.order.schedule_event.starts_at,
                  "dddd, D/MM/YYYY [às] HH[hrs]"
                )
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("Duração:")]),
          _vm._v(
            "\n      " +
              _vm._s(
                _vm._f("durationInHous")(_vm.order.schedule_event.duration)
              ) +
              "\n    "
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-653cb3bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-653cb3bf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Orders/Rebooking/Details.vue
// module id = null
// module chunks = 